import { Link } from 'react-router-dom';
import AvatarMenu from './AvatarMenu';

export default function Header() {
  return (
    /* DW-6 — `relative z-20`, the `appHeader` rung. The whole ladder and every
       surface on it live in `src/lib/ui/zIndexLadder.ts` (DW-366), checked
       against this file by `src/lib/ui/__tests__/zIndexLadder.test.ts`.

       Why THIS file is on THIS rung: the header is UNPOSITIONED by default, so
       any positioned `z-10` surface paints over it — the `/tasks` detail sheet
       was `fixed inset-0 z-10` and covered the whole viewport INCLUDING this
       band, so with a ticket open the band's controls were unreachable.
       Raising the header into its own stacking layer puts it above the sheet.

       Story 24.7 — `hidden lg:block`: below 1024px there is NO global header
       (DESIGN.md A2). Each page's PageHeader is the header there, and the
       BottomTabBar — on the same `appHeader` rung — carries navigation. The
       hamburger and the drawer it opened are gone.

       Ordering alone was not enough, though, and the rest of the fix lives in
       `TaskDetailDrawer`: winning the z contest just moved the buried control,
       burying the sheet's own Close button under this band instead. The sheet
       is now `absolute inset-0` against the route area, so the two surfaces do
       not contest a pixel at all — this band is simply not the sheet's to
       cover. Both halves are load-bearing; neither works alone. */
    <header className="hidden lg:block relative z-20 bg-canvas border-b border-line">
      {/* T-20260916-5 — the band is 56px: `py-1.5` is 6px a side around the
          44px touch floor, 6 + 44 + 6 = 56. (`py-4` was ~76px of chrome on
          every route.)

          🔴 PADDING CAME OUT, CONTROLS DID NOT. The tappable control in this
          band — the Account trigger — is 44px, so 44px is
          the FLOOR of this band and there is no further height to take here
          without breaking the touch target. Trim the padding again and you get
          44px and a control flush to both edges; trim the control and you get
          a target a thumb misses. `min-h-14` holds the 56px (DESIGN.md
          `app-header`) as a floor on its own as well.

          Story 24.5 — the bar holds the logo and the AvatarMenu only. The
          wordmark is a `<span>`, not a heading: the page's own PageHeader
          carries the one `h1`. Its `text-2xl` line box is 32px, inside the
          floor.

          `relative z-20` on the <header> above is NOT part of this and must not
          move — see the DW-6 note. */}
      <div className="flex min-h-14 items-center justify-between px-4 py-1.5 sm:px-6 lg:px-8">
        <div className="flex items-center">
          <Link to="/start" className="flex items-center rounded-md focus-ring">
            {/* Canonical wordmark: Playfair Display (font-editorial) in ink,
                the ".ai" in the link role (teal-800, AA on canvas — the old
                teal-500 spark was 2.54:1). */}
            <span className="font-editorial text-2xl font-medium text-ink">
              amatis<span className="text-link">.ai</span>
            </span>
          </Link>
        </div>

        <AvatarMenu />
      </div>
    </header>
  );
}
